module.exports = __webpack_public_path__ + "static/demos_magen-a3f78df27e385f21a012a7e774c10732.jpg";